import { render, staticRenderFns } from "./ItemizedInvoicesTable.vue?vue&type=template&id=45323d7a&scoped=true"
import script from "./ItemizedInvoicesTable.vue?vue&type=script&lang=js"
export * from "./ItemizedInvoicesTable.vue?vue&type=script&lang=js"
import style0 from "./ItemizedInvoicesTable.vue?vue&type=style&index=0&id=45323d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45323d7a",
  null
  
)

export default component.exports